const prefix = 'socan-unitadmin-'
export const localStore = {
    makeKey: (key: string) => {
        return `${prefix}${key}`
    },
    getItem: (key: string) => {
        return localStorage.getItem(localStore.makeKey(key))
    },
    setItem: (key: string, value: string) => {
        return localStorage.setItem(localStore.makeKey(key), value)
    },
    remove: (key: string) => {
        return localStorage.remove(localStore.makeKey(key))
    },
    removeItem: (key: string) => {
        return localStorage.removeItem(localStore.makeKey(key))
    },
}
